import { Loading } from "element-ui";
import { mapGetters } from "vuex";

export default {
    data() {
        return {
            loadDialog: undefined
        }
    },
    props: {
        dialog: Boolean,
    },
    computed: {
        ...mapGetters({
            dialogFullscreen: 'dialogFullscreen',
            labelPosition: 'labelPosition',
        }),
    },
    methods: {
        loadStart() {
            this.loadDialog = Loading.service({
                target: document.getElementById(this.$options.name).getElementsByClassName("el-dialog")[0]
            });
        },
        fetchNoDialog() {
            const parentName = this.$parent.$options.name;
            const dialogName = this.$options.name;
            this.refresh.$emit(parentName, function () {
                this.fetchData();
                this[dialogName] = false;
            })
        },
        noDialog() {
            const parentName = this.$parent.$options.name;
            const dialogName = this.$options.name;
            this.$parent[dialogName] = false
            this.refresh.$emit(parentName, function () {
                this[dialogName] = false;
            })
        },
    },
    mounted() {
        this.refresh.$on(this.$options.name, (callBack) => {
            if (typeof callBack === "function") {
                callBack.call(this)
            }
        });
    },
}
